// Reads the user's reputation (users.reputation_score) and reward inventory
// (user_inventory) — the existing reward model.

import { supabase } from './supabaseClient';

export interface InventoryItem {
  id: string;
  item_type: string;
  amount: number;
  source_campaign_id: string | null;
  created_at: string;
}

export interface Reputation {
  score: number;
  inventory: InventoryItem[];
}

export const fetchReputation = async (): Promise<Reputation> => {
  const { data: { user } } = await supabase.auth.getUser();
  if (!user) return { score: 0, inventory: [] };

  const [{ data: profile }, { data: inv }] = await Promise.all([
    supabase.from('users').select('reputation_score').eq('id', user.id).maybeSingle(),
    supabase
      .from('user_inventory')
      .select('id, item_type, amount, source_campaign_id, created_at')
      .eq('user_id', user.id)
      .order('created_at', { ascending: false })
      .limit(20),
  ]);

  return {
    score: profile?.reputation_score ?? 0,
    inventory: (inv as InventoryItem[]) || [],
  };
};
